import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import styles from './DocumentModal.module.css'
import {FaFilePdf, FaFileWord, FaFileImage, FaFile} from 'react-icons/fa'

interface Document {
  id: number
  documentName: string
}

interface DocumentModalProps {
  isOpen: boolean
  onClose: () => void
  claimNumber: string
  token?: string
}

const DocumentModal: React.FC<DocumentModalProps> = ({isOpen, onClose, claimNumber, token}) => {
  const [documents, setDocuments] = useState<Document[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isOpen && token) {
      setIsLoading(true)
      const dateStr = new Date().toISOString().split('T')[0]
      const url = `${process.env.REACT_APP_API_CLAIM_URL}/api/Claims/DailyMonitoring?ClaimNumber=${claimNumber}&Date=${dateStr}`
      const headers = {
        Authorization: `Bearer ${token}`,
      }

      fetch(url, {headers})
        .then((response) => response.json())
        .then((data) => {
          console.log('Fetched data:', data.data)
          setDocuments(data.data.documents)
        })
        .catch((error) => console.error('Failed to fetch documents', error))
        .finally(() => setIsLoading(false))
    }
  }, [isOpen, claimNumber, token])

  const getFileIcon = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase()
    switch (ext) {
      case 'pdf':
        return <FaFilePdf className={styles.iconPdf} />
      case 'doc':
      case 'docx':
        return <FaFileWord className={styles.iconDoc} />
      case 'jpg':
      case 'jpeg':
      case 'png':
        return <FaFileImage className={styles.iconImage} />
      default:
        return <FaFile className={styles.iconDefault} />
    }
  }

  const handleDocumentClick = (doc: Document) => {
    // Handle document click - you can add download or preview functionality here
    console.log('Document clicked:', doc)
  }

  return (
    <Modal show={isOpen} onHide={onClose} size='lg' className={styles.modal}>
      <Modal.Header closeButton>
        <Modal.Title>Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.documentContainer}>
          {isLoading ? (
            <div className={styles.loading}>Loading documents...</div>
          ) : documents.length > 0 ? (
            <div className={styles.documentList}>
              {documents.map((doc) => (
                <div
                  key={doc.id}
                  className={styles.documentItem}
                  onClick={() => handleDocumentClick(doc)}
                >
                  <span className={styles.iconWrapper}>{getFileIcon(doc.documentName)}</span>
                  <div className={styles.documentInfo}>
                    <div className={styles.fileName}>{doc.documentName}</div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.noDocuments}>No documents available</div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default DocumentModal
